(function () {
    'use strict';

    angular.module('app.common', []);

    //shell.config(['$routeProvider', function ($routeProvider) {
    //}]); 

})();